import saveState from 'vue-save-state';

export default {
    mixins: [saveState],
    methods: {
        getSaveStateConfig() {
            return {
                'cacheKey': `${this.$options.name}`,
                'saveProperties': ['page', 'perPage']
            };
        }
    },
    defaultPerPage: 100
}